import { type AsyncNamespaceInput, type NexusHandler } from "@otto-ec/global-resources/nexus";
import type { PushOptions } from "./SnackbarV1.types.js";
import type { SnackbarV1 } from "./index.js";

export const openSnackbar = function openSnackbar(id: string) {
  const snackbar = document.getElementById(id) as HTMLOcSnackbarV1Element | null;

  if (snackbar) {
    snackbar.open = true;
  }
} satisfies NexusHandler<SnackbarV1["open"]>;

export const closeSnackbar = function closeSnackbar(id: string) {
  const snackbar = document.getElementById(id) as HTMLOcSnackbarV1Element | null;

  if (snackbar) {
    snackbar.open = false;
  }
} satisfies NexusHandler<SnackbarV1["close"]>;

export const closeAllSnackbars = function closeAllSnackbars() {
  const snackbars = document.querySelectorAll("oc-snackbar-v1");

  snackbars.forEach((snackbar) => {
    snackbar.open = false;
  });
} satisfies NexusHandler<SnackbarV1["closeAll"]>;

export const pushSnackbar = function pushSnackbar(message: string, options?: PushOptions) {
  const snackbar = document.createElement("oc-snackbar-v1") as HTMLOcSnackbarV1Element;
  snackbar.message = message;
  if (options?.autoDismiss !== undefined) snackbar.autoDismiss = options.autoDismiss;

  if (options?.actions) {
    const ALLOWED_TAG = "oc-link-v2";
    const parsed = new DOMParser().parseFromString(options.actions, "text/html");
    const slot = document.createDocumentFragment();
    for (const el of parsed.body.children) {
      if (ALLOWED_TAG === el.tagName.toLowerCase()) {
        const allowed = el.cloneNode(true) as Element;
        allowed.setAttribute("slot", "actions");
        /*                                                                          */
        for (const node of [allowed, ...allowed.querySelectorAll("*")]) {
          for (const attr of [...(node as Element).attributes]) {
            if (attr.name.startsWith("on")) (node as Element).removeAttribute(attr.name);
          }
        }
        slot.appendChild(allowed);
      }
    }
    snackbar.appendChild(slot);
  }

  document.body.append(snackbar);
  snackbar.open = true;
  /*                                                                                        */
  snackbar.addEventListener("oc-snackbar-close", () => setTimeout(() => snackbar.remove(), 500), {
    once: true,
  });
} satisfies NexusHandler<SnackbarV1["push"]>;

/*                                                                               */
export const snackbarV1: AsyncNamespaceInput<OttoComponentApi["snackbarV1"]> = {
  open: openSnackbar,
  close: closeSnackbar,
  closeAll: closeAllSnackbars,
  push: pushSnackbar,
};
